import React from "react"
import { Box, Container, Table, TableHead, TableBody, TableRow, TableCell } from "@mui/material"

import { SeriesModel } from "utils/commerceTools/formatters/formatSeries"

const CompareModels = ({ models, name }: Props) => {
	return (
		<Box my={10} style={{ position: "relative", zIndex: 1 }}>
			<Container>
				<div
					style={{
						overflowX: "scroll",
						boxShadow: "0 10px 20px rgba(0, 0, 0, 0.27)",
						background: "#182F37",
						color: "white",
						borderRadius: 5,
					}}
					className="scrollX-no-scrollbar"
				>
					<Box
						px={5}
						pt={3}
						pb={5}
						style={{
							minWidth: 900,
						}}
					>
						<div>
							<h3 style={{ fontSize: 18 }}>Die {name} Serie im Vergleich</h3>
						</div>
						<Table>
							<TableHead>
								<TableRow>
									<TableCell
										style={{ fontWeight: 800, opacity: 0.5, color: "#fff" }}
									>
										Name
									</TableCell>
									<TableCell
										align="right"
										style={{ fontWeight: 800, opacity: 0.5, color: "#fff" }}
									>
										Außenmaße in cm
									</TableCell>
									<TableCell
										align="right"
										style={{ fontWeight: 800, opacity: 0.5, color: "#fff" }}
									>
										Innenmaße in cm
									</TableCell>
									<TableCell
										align="right"
										style={{ fontWeight: 800, opacity: 0.5, color: "#fff" }}
									>
										Gewicht
									</TableCell>
									<TableCell
										align="right"
										style={{ fontWeight: 800, opacity: 0.5, color: "#fff" }}
									>
										Volumen
									</TableCell>
									{/* <TableCell align="right" style={{fontWeight:800}}>Fachböden</TableCell>
								<TableCell align="right" style={{fontWeight:800}}>Anz. Schlüsselhaken</TableCell> */}
								</TableRow>
							</TableHead>

							<TableBody>
								{models.map((product) => {
									if (!product) return null
									const { id, name, attributes } = product

									return (
										<TableRow key={id} style={{ color: "#fff" }}>
											<TableCell
												component="th"
												scope="row"
												style={{ color: "#fff" }}
											>
												{name}
											</TableCell>
											<TableCell align="right" style={{ color: "#fff" }}>
												H{attributes.outerHeight} x B{attributes.outerWidth}{" "}
												x T{attributes.outerDepth}
											</TableCell>
											<TableCell align="right" style={{ color: "#fff" }}>
												H{attributes.innerHeight} x B{attributes.innerWidth}{" "}
												x T{attributes.innerDepth}
											</TableCell>
											<TableCell align="right" style={{ color: "#fff" }}>
												{attributes.weightKg} Kg
											</TableCell>
											<TableCell align="right" style={{ color: "#fff" }}>
												{attributes.volumeLiter} L
											</TableCell>
										</TableRow>
									)
								})}
							</TableBody>
						</Table>
					</Box>
				</div>
			</Container>
		</Box>
	)
}

interface Props {
	models: SeriesModel[]
	name: string
}

export default CompareModels
